import { FeatureToggleClientService } from 'feature-toggle-client';
const CONFIGURATION_TOKEN_MANAGEMENT = 'configuration-token-management';
const CONFIGURATION_MIMETYPE_MANAGEMENT = 'configuration-mimetype-management';
const CONFIGURATION_FILTER_OWNERS = 'is-filtering-owners-in-advanced-configuration';
const HIDE_BOT_ACCESS_KEY_IN_PORTAL = 'hide-bot-access-key-in-portal';
const USE_SANITIZE_ACCESS_KEY_IN_BOT = 'use-sanitize-access-key-in-bot';
const BLOCK_ADD_VIEW_PLUGINS_ADVANCED_BOT_CONFIGURATION = 'block-add-view-plugins-advanced-bot-configuration';
const USE_CONFIGURATIONS_DOMAIN_ON_ADVANCED_CONFIGURATION_PROPERTIES_GET = 'use-configurations-domain-on-advanced-configuration-properties-get';
const USE_CONFIGURATIONS_DOMAIN_ON_ADVANCED_CONFIGURATION_PROPERTIES_SET = 'use-configurations-domain-on-advanced-configuration-properties-set';
export class ConfigurationFeatures {
    static isTokenManagementEnable() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(CONFIGURATION_TOKEN_MANAGEMENT, false);
    }
    static isMimeTypeManagementEnable() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(CONFIGURATION_MIMETYPE_MANAGEMENT, false);
    }
    static async isFilteringOwnersInAdvancedConfigurations() {
        return await FeatureToggleClientService.getInstance().isFeatureEnabled(CONFIGURATION_FILTER_OWNERS, false);
    }
    static hideBotAccessKeyEnabled() {
        return FeatureToggleClientService.getInstance()
            .isApplicationFeatureEnabled(HIDE_BOT_ACCESS_KEY_IN_PORTAL);
    }
    static isSanitizeAccessKeyInBot() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(USE_SANITIZE_ACCESS_KEY_IN_BOT, false);
    }
    static isBlockAddViewPluginsAdvancedBotConfiguration() {
        return FeatureToggleClientService.getInstance()
            .isUserFeatureEnabled(BLOCK_ADD_VIEW_PLUGINS_ADVANCED_BOT_CONFIGURATION, false);
    }
    static isConfigurationDomainOnAdvancedConfigurationPropertiesGetEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(USE_CONFIGURATIONS_DOMAIN_ON_ADVANCED_CONFIGURATION_PROPERTIES_GET, false);
    }
    static isConfigurationDomainOnAdvancedConfigurationPropertiesSetEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(USE_CONFIGURATIONS_DOMAIN_ON_ADVANCED_CONFIGURATION_PROPERTIES_SET, false);
    }
}
